import React from 'react';
import styled from 'styled-components';
import { formatDistanceToNow } from 'date-fns';

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.$isOwn ? 'flex-end' : 'flex-start'};
  max-width: 80%;
  align-self: ${props => props.$isOwn ? 'flex-end' : 'flex-start'};
`;

const MessageBubble = styled.div`
  background-color: ${props => props.$isOwn ? props.theme.colors.primary : 'white'};
  color: ${props => props.$isOwn ? 'white' : props.theme.colors.text};
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  border-bottom-right-radius: ${props => props.$isOwn ? '0.25rem' : '1rem'};
  border-bottom-left-radius: ${props => props.$isOwn ? '1rem' : '0.25rem'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;
`;

const MessageTime = styled.div`
  font-size: 0.7rem;
  color: ${props => props.theme.colors.textSecondary};
  margin-top: 0.25rem;
`;

const ChatMessage = ({ message, isOwn }) => {
  // Format the timestamp to show relative time (e.g., "5 minutes ago")
  const formattedTime = message.timestamp?.toDate 
    ? formatDistanceToNow(message.timestamp.toDate(), { addSuffix: true }) 
    : 'just now';

  return (
    <MessageContainer $isOwn={isOwn}>
      <MessageBubble $isOwn={isOwn}>
        {message.content}
      </MessageBubble>
      <MessageTime>{formattedTime}</MessageTime>
    </MessageContainer>
  );
};

export default ChatMessage; 